import React from 'react';
import { Star, StarFill } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';
import { FAVORITE_STAR_COLOR } from '../../utils/favoriteTickers';

/**
 * Gold star toggle for adding a ticker to Favorites.
 */
export default function FavoriteStar({
  ticker,
  favorited,
  onToggle,
  size = 13,
  disabled = false,
}) {
  const { colors } = useTheme();
  const symbol = String(ticker || '').toUpperCase();
  const Icon = favorited ? StarFill : Star;

  return (
    <button
      type="button"
      data-testid={`favorite-star-${symbol}`}
      aria-label={favorited ? `Remove ${symbol} from favorites` : `Add ${symbol} to favorites`}
      aria-pressed={favorited}
      disabled={disabled || !symbol}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (symbol) onToggle?.(symbol);
      }}
      style={{
        width: 22,
        height: 22,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        border: 'none',
        borderRadius: 999,
        background: 'transparent',
        color: favorited ? FAVORITE_STAR_COLOR : colors.textMuted,
        cursor: disabled || !symbol ? 'default' : 'pointer',
        flexShrink: 0,
      }}
    >
      <Icon size={size} color={favorited ? FAVORITE_STAR_COLOR : colors.textMuted} />
    </button>
  );
}
